import type { StripeElementsOptionsClientSecret } from '@stripe/stripe-js'

export const CHECK_UP_PRICE_IN_CENTS_TTC = 360000
export const CHECK_UP_PRICE_IN_CENTS_HT = 300000

export const CHECK_UP_LOCATION = {
  label: 'Zoī Vendōme',
  address: '12, rue Volney, 75002 Paris',
  link: 'https://maps.app.goo.gl/ap5SeEtppMs3J7zL8'
}

/**
 * Should only handle UI / appearance options as payment intent is handled
 * by the backend in the payment transaction
 */
export const CHECK_UP_STRIPE_OPTIONS = {
  // See https://stripe.com/docs/stripe-js/appearance-api
  appearance: {
    disableAnimations: false,
    variables: {},
    theme: 'stripe',
    labels: 'above'
  }
} satisfies StripeElementsOptionsClientSecret
